import { PageSkeleton } from '@navio-maritime/ui';
import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/context/AuthContext';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();
  if (loading) return <FullScreenLoading />;
  if (!session) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function FullScreenLoading() {
  return <PageSkeleton showHeader={false} showFilters={false} variant="detail" />;
}
